import moment from "moment"

export const toMoney = (val) => val.replace('R$ ', '').replace(',', '.')
export const stringToNumber = (val) => val.replace('R$ ', '').replace(',', '').replace('.', '')

export const matriculaTransforma = (val) => val.replace(/ /g, '')

export const iniciaisSolicitante = (val) => {
  return val.split(' ')
.map((n) => n[0] && n[0].toUpperCase())
.join('')
}

export const realToCents = (real) => {
  if (typeof real == `string`) {
    let replaces = ["R", "$", ".", ","]
    let cents = []
    for (let key in real) {
      if (replaces.indexOf(real[key]) === -1) {
        cents.push(real[key])
      }
    }
    real = cents.join('')
    return parseInt(real)
  } else {
    return real
  }
}

export function formatString (input) {
  // Divida a string em palavras usando o caractere "_"
  const words = input.split('_')

  // Mapeie cada palavra e capitalize a primeira letra
  const formattedWords = words.map(word => word.charAt(0).toUpperCase() + word.slice(1))

  // Junte as palavras com espaço
  const result = formattedWords.join(' ')

  return result
}

export const moneyToNumber = (val) => Number(val.replace('R$ ', '').replace(',', '').replace('.', ''))

export const numberToMoney = (centavos) => {
  const reais = centavos / 100
  return `R$ ${reais.toFixed(2).replace('.', ',')}`
}

export const toValidType = (val) => `R$ ${val.replace(',', ',')}`

export const brDateToDatabaseFormat = (val) => moment(val, 'DD-MM-YYYY').format('YYYY-MM-DD')

export const dataBaseFormatToBr = (val) => moment(val, 'YYYY-MM-DD').format('DD-MM-YYYY')

export function formatarCamposErrorMessage (arr) {
  const resultado = arr.map(item => {
    const palavras = item.split('_')
    const palavrasFormatadas = palavras.map(palavra => {
      return palavra.charAt(0).toUpperCase() + palavra.slice(1)
    })
    return palavrasFormatadas.join(' ')
  })

  return resultado.join(', ') + '.'
}